/* ---------- marble slab: one image behind the whole page, gliding slowly ---------- */
(function () {
  var img = document.querySelector('.hx-slab-img');
  if (!img) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var queued = false;
  function update() {
    queued = false;
    var vh = window.innerHeight;
    var travel = Math.max(0, img.offsetHeight - vh);
    var scrollable = Math.max(1, document.documentElement.scrollHeight - vh);
    var rate = Math.min(0.35, travel / scrollable);
    var y = Math.min(travel, Math.max(0, window.pageYOffset || 0) * rate);
    img.style.transform = 'translate3d(0,' + (-y).toFixed(1) + 'px,0)';
  }
  function queue() { if (!queued) { queued = true; window.requestAnimationFrame(update); } }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  window.addEventListener('load', queue);
  update();
})();
